/**
 * No Base Model Placeholder
 *
 * Shown in the gallery when the customer is configuring accessories without a base
 * model. The gallery would otherwise fall back to the generic initial image, which
 * shows a truck they have not chosen.
 *
 * The faded vehicle photo behind this copy is a CSS background rather than an <img>:
 * it is purely decorative, and the two lines below are what carry the meaning.
 *
 * @package
 */

import { __ } from '@wordpress/i18n';

const NoBaseModelPlaceholder = () => (
	<div className="configurator-gallery-placeholder">
		<p className="configurator-gallery-placeholder-text">
			{ __( 'No base model selected', 'at-vehicle-configurator' ) }
		</p>
		<p className="configurator-gallery-placeholder-hint">
			{ __( 'Pick a base model to preview your build, or carry on choosing accessories.', 'at-vehicle-configurator' ) }
		</p>
	</div>
);

export default NoBaseModelPlaceholder;
